/**
 * Dashboard Design Tokens
 *
 * Shared visual constants used by amCharts 5, AG Grid, and KPI cards
 * to ensure visual unity across all dashboard block types.
 */

export const DASHBOARD_TOKENS = {
  // Background layers
  bgPrimary: '#0b1219',
  bgCard: '#131c27',
  bgHover: '#1a2536',
  bgHeader: '#0f1720',

  // Borders
  borderDefault: '#1e2d3d',
  borderSubtle: '#162030',

  // Text
  textPrimary: '#e0e8f0',
  textSecondary: '#8899aa',
  textMuted: '#5a7189',

  // Data colors (ordered palette for chart series)
  palette: [
    '#3b82f6', // blue
    '#10b981', // green
    '#f59e0b', // amber
    '#ef4444', // red
    '#0d9488', // teal
    '#06b6d4', // cyan
    '#ec4899', // pink
    '#84cc16', // lime
    '#0891b2', // sky-cyan-dark
    '#78716c', // stone
  ],

  // Semantic colors
  blue: '#3b82f6',
  green: '#10b981',
  amber: '#f59e0b',
  red: '#ef4444',
  teal: '#0d9488',
  cyan: '#06b6d4',
  pink: '#ec4899',
  lime: '#84cc16',

  // Typography
  fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
  fontSize: 13,
  fontSizeSmall: 11,
  fontSizeLarge: 15,

  // Spacing & radii
  cornerRadius: 4,
  cardBorderRadius: 8,
  spacing: 6,
} as const;

export type DashboardTokens = typeof DASHBOARD_TOKENS;
